"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineageAnchor = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Localize_1 = require("../../../gen-src/Localize");
var PrepFlowAnnotationsFilter_1 = require("../../../gen-src/icons/PrepFlowAnnotationsFilter");
var LineageCartoucheStyles_1 = require("../style/LineageCartoucheStyles");
var LineageIconButton_1 = require("./LineageIconButton");
var selectedMessagesForAnchorType = {
    dashboard: Localize_1.Messages.XFieldSelected,
    database: Localize_1.Messages.XTableSelected,
    datasource: Localize_1.Messages.XFieldSelected,
    flow: Localize_1.Messages.XFieldSelected,
    lens: Localize_1.Messages.XFieldSelected,
    metric: function () { return ''; },
    sheet: Localize_1.Messages.XFieldSelected,
    table: Localize_1.Messages.XColumnSelected,
    user: function () { return ''; },
    virtualConnection: Localize_1.Messages.XTableSelected,
    virtualConnectionTable: Localize_1.Messages.XColumnSelected,
    workbook: Localize_1.Messages.XFieldSelected,
};
function LineageAnchor(props) {
    var anchorName = props.anchorName ? props.anchorName : Localize_1.Messages.PermissionsRequired();
    return (React.createElement(LineageCartoucheStyles_1.AnchoredLineageItemContainer, null,
        React.createElement(LineageIconButton_1.LineageIconButton, { isCurrentPane: props.isCurrentPane, linkHref: props.linkHref, lineageItemType: props.lineageItemType, buttonAltText: props.buttonAltText }),
        React.createElement(react_router_dom_1.Link, { to: props.linkHref, className: LineageCartoucheStyles_1.anchoredContentInfoItemClass },
            React.createElement(LineageCartoucheStyles_1.LineageContentInfoItemAnchorRow, null,
                React.createElement("span", { className: data_catalog_shared_1.classes(LineageCartoucheStyles_1.anchorNameClass, props.isCurrentPane && LineageCartoucheStyles_1.boldLineageItemClass), title: anchorName }, anchorName)),
            React.createElement(LineageCartoucheStyles_1.LineageContentInfoItemAnchorRow, null,
                React.createElement("span", { className: data_catalog_shared_1.classes(props.isCurrentPane && LineageCartoucheStyles_1.boldLineageItemClass) },
                    props.label,
                    " ",
                    props.anchorCount),
                props.isFilteredOnThisType
                    ? (React.createElement(LineageCartoucheStyles_1.LineageContentInfoItemAnchorRowSelected, null,
                        React.createElement(PrepFlowAnnotationsFilter_1.SvgPrepFlowAnnotationsFilter, { className: LineageCartoucheStyles_1.filteredOnItemIndicatorClass }),
                        React.createElement("span", null, selectedMessagesForAnchorType[props.lineageItemType]({
                            COUNT: props.selectedItemCount,
                            COUNT_LOC: Localize_1.Formatters.formatCount(props.selectedItemCount)
                        }))))
                    : null))));
}
exports.LineageAnchor = LineageAnchor;
//# sourceMappingURL=LineageAnchor.js.map